import React from 'react';
import { Button, Card, Icon } from '@wegroup/design-system';

// Components
import OptionButton from '../../../../../../common/src/components/OptionButton';
import AccidentDisplay from './AccidentDisplay';

// Types
import { Accident } from '../../../../../../../types/ProductFactory';
import { useTranslation } from 'react-i18next';
import AccidentEditModal from './AccidentEditModal';
interface Props {
  isMobile?: boolean;
  isEditing: boolean;
  setIsEditing: (arg0: boolean) => void;
  accident: Accident;
  handleEdit: (arg0: Accident) => void;
  handleRemove: () => void;
}

const SingleAccident: React.FC<React.PropsWithChildren<Props>> = ({
  isMobile,
  accident,
  isEditing,
  handleEdit,
  handleRemove,
  setIsEditing,
}) => {
  const { t } = useTranslation();

  const finishEdit = (accident: Accident) => {
    setIsEditing(false);
    handleEdit(accident);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleMobileClick = () => {
    if (isMobile) setIsEditing(true);
  };

  return (
    <Card h="100%" position="relative" overflow="unset">
      <AccidentEditModal
        isOpen={isEditing}
        onSave={finishEdit}
        onCancel={handleCancel}
        onRemove={handleRemove}
        accident={accident}
      />
      <AccidentDisplay accident={accident} onClick={handleMobileClick} />
      {isMobile && (
        <Button
          mt="3"
          variant="white"
          leftIcon={<Icon name="GeneralActionsEditDocument" />}
          aria-label="edit-button"
          onClick={handleMobileClick}
        >
          {t('EDIT')}
        </Button>
      )}
      {!isMobile && (
        <OptionButton
          editText={t('Edit accident')}
          removeText={t('Remove accident')}
          onEdit={() => setIsEditing(true)}
          onRemove={handleRemove}
        />
      )}
    </Card>
  );
};

export default SingleAccident;
